export default function stickyNav() {
    const head = document.querySelector("#gh-head");
    if (!head) return;

    let lastY = window.scrollY;
    let ticking = false;

    const update = () => {
        const y = window.scrollY;
        const atTop = y <= 4;

        head.classList.toggle("is-stuck", !atTop);

        if (atTop) {
            head.classList.remove("is-hidden");
        } else if (y > lastY && y > 80) {
            head.classList.add("is-hidden");
        } else if (y < lastY) {
            head.classList.remove("is-hidden");
        }

        lastY = y;
        ticking = false;
    };

    update();
    window.addEventListener("scroll", () => {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
        }
    }, { passive: true });
}
